import { render, staticRenderFns } from "./HomeMaintenance.vue?vue&type=template&id=10cb6566&scoped=true&"
var script = {}
import style0 from "./HomeMaintenance.vue?vue&type=style&index=0&id=10cb6566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cb6566",
  null
  
)

export default component.exports